<odx-content-box
  class="content-box flex-column"
  odxLayout="flex gap-none"
  [ngClass]="{
    selected: quantity() > 0,
  }"
  (click)="onCardClicked()"
>
  <odx-area-header class="header">
    <h6
      class="odx-heading-5 card-title"
      (click)="onTooltipClicked($event)"
      [odxTooltip]="product() | localizeProductName"
      [odxTooltipVisible]="tooltipVisible()"
      [odxTooltipDisabled]="isTooltipDisabled()"
      odxTooltipSize="large"
    >
      {{ product() | localizeProductName | displayName }}
    </h6>
  </odx-area-header>
  <div class="h-100 content">
    <div class="image-wrapper">
      <app-product-image
        [product]="product()"
        [imageUrl]="imageUrl()"
        [fallbackImageUrl]="fallbackImageUrl()"
      ></app-product-image>
    </div>
    <ng-content></ng-content>
    <form odxForm [formGroup]="form" (click)="$event.stopPropagation(); $event.preventDefault()">
      <odx-form-field i18n-label="@@global.quantity" label="Anzahl">
        <div odxLayout="flex" class="custom-spinbox">
          <button
            type="button"
            data-icon-set="core"
            data-icon-name="minus"
            class="odx-spinbox__action odx-icon"
            (click)="decrement()"
          ></button>
          <input class="odx-spinbox__input" odxFormFieldControl type="number" [formControlName]="'quantity'" />
          <button
            type="button"
            data-icon-set="core"
            data-icon-name="plus"
            class="odx-spinbox__action odx-icon"
            (click)="increment()"
          ></button>
        </div>
      </odx-form-field>
    </form>
  </div>
  <odx-content-box-footer class="footer w-100">
    <div odxLayout="flex" class="space-between">
      <!-- do not propagate radio button click to prevent from multiple click events when card is clicked -->
      @if (selectionMode() === "single") {
        <odx-radio-button (click)="$event.stopPropagation()" [value]="product()" i18n="@@global.select"
          >Auswählen</odx-radio-button
        >
      }
      <!-- do not propagate checkbox click to prevent from multiple click events when card is clicked -->
      @if (selectionMode() === "multi") {
        <odx-checkbox
          (click)="$event.stopPropagation()"
          [checked]="form.value.quantity! > 0"
          (checkedChange)="onCheckedChanged($event)"
          #checkbox
          i18n="@@global.select"
          >Auswählen</odx-checkbox
        >
      }
      <p>{{ showCosts() && priceData() ? (priceData()!.price | currency: priceData()!.currencyCode) : "" }}</p>
    </div>
  </odx-content-box-footer>
</odx-content-box>
